/**
 * Copyright Motili Inc., 2016 All Rights Reserved
 */


import React from 'react';
import ReactDOM from 'react-dom';
import {
    Router,
    hashHistory
} from 'react-router';

import '../style/sass/index.scss';

/**
 * Define our entry route with child routes.
 * This is a plain route syntax used by react-router that allows us to easily define onEnter hooks, async route loading, etc.
 */
const rootRoute = {
    childRoutes: [
        {
            path: '/',
            component: require('./components/Router'), // eslint-disable-line global-require
            indexRoute: require('./components/index/route.MicroSitesIndex'), // eslint-disable-line global-require
            childRoutes: [
                require('./components/contractor-rating/route.ContractorRating'), // eslint-disable-line global-require
                require('./components/check-in/route.CheckIn'), // eslint-disable-line global-require
                require('./components/scheduling/route.WorkOrderScheduling'), // eslint-disable-line global-require
                require('./components/order/order-pickup/route.OrderPickUp'), // eslint-disable-line global-require
                require('./components/order/order-shipping/route.OrderShipping'), // eslint-disable-line global-require
                require('./components/order/order-return/route.OrderReturn'), // eslint-disable-line global-require
                require('./components/quote/quote-approval/route.QuoteApproval'), // eslint-disable-line global-require
                require('./components/not-found/route.NotFound'), // eslint-disable-line global-require
            ]
        },
        require('./components/not-found/route.NotFound') // eslint-disable-line global-require
    ]
};
ReactDOM.render((
    <Router
        history={hashHistory}
        routes={rootRoute}
    />
), document.getElementById('app')); // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./src/app/index.js